import './CheckboxGroup.scss';

/** Checkbox button group form control used to select a value out an array of options. */
export const CheckboxGroup = ({
  label,
  name,
  onValueChange,
  options,
  value
}) => {
  const isOptionChecked = (
    value instanceof Set
    ? (option) => value.has(option.value)
    : (option) => value.includes(option.value)
  );

  return (
    <div className="checkbox-group">
      <label className="control-label" htmlFor={name}>{label}</label>
      <div className="checkbox-options">
        {options.map((option) =>
          <label className="checkbox-option" key={option.label}>
            <input
              type="checkbox"
              checked={isOptionChecked(option)}
              onChange={(event) => {
                onValueChange(option.value, event.target.checked);
              }}
            />
            {option.label}
          </label>
        )}
      </div>
    </div>
  );
};
